import { api } from '@/api/core';
import { CHAT_SHARING_TAG } from '@/api/constants';
import { SetChatUserAccessRequest, SetChatUserAccessResponse } from './types';

const setChatUserAccessApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /** Applies every add, re-level and revoke from the modal in one request, on "Save Changes". */
    setChatUserAccess: builder.mutation<SetChatUserAccessResponse, SetChatUserAccessRequest>({
      query: ({ chatId, users }) => ({
        url: 'chat/set-user-access',
        method: 'POST',
        body: { chatId, users },
      }),
      invalidatesTags: (_result, _error, { chatId }) => [{ type: CHAT_SHARING_TAG, id: chatId }],
    }),
  }),
});

export const { useSetChatUserAccessMutation } = setChatUserAccessApi;
